import { CustomerType } from '@repo/common';
import { z } from 'zod';

export const CustomerFormSchema = z
    .object({
        name: z.string().min(2, 'Name must be at least 2 characters long'),
        email: z.string().optional(),
        phone_number: z
            .string()
            .min(2, 'Phone number must be at least 3 characters long'),
        address: z.string().optional(),
        customer_type: z.nativeEnum(CustomerType),
        password: z.string().optional(),
    })
    .superRefine((data, ctx) => {
        if (data.customer_type === CustomerType.WHOLESALE) {
            if (!data.password || data.password.length < 4) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: ['password'],
                    message:
                        'Password is required and must be at least 4 characters long for Wholesale customers',
                });
            }
        }
    });

export type TCustomerForm = z.infer<typeof CustomerFormSchema>;

export const CustomerFormDefaultValues: TCustomerForm = {
    name: '',
    email: '',
    phone_number: '',
    address: '',
    customer_type: CustomerType.RETAIL,
    password: '',
};
